import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import HitArea from 'components/HitArea'
import Box from 'components/Box'
import { useLocation, useHistory, useRouteMatch } from 'react-router-dom'
import { VersionLink } from 'modules/versioning'

const animationTypeToTransitionType = {
  FROM_BOTTOM: 'fromBottom',
  FROM_LEFT: 'fromLeft',
  FROM_RIGHT: 'fromRight',
  FROM_TOP: 'fromTop',
  NONE: 'none',
}

const stopPropagation = e => e.stopPropagation()
const px = x => x + 'px'

const HitAreaBox = HitArea.withComponent(Box)
const VersionLinkHitAreaBox = HitAreaBox.withComponent(VersionLink)

const Hotzone = ({
  isBackAction,
  animationType,
  destinationArtboardPermShortId,
  width,
  height,
  scale,
  top,
  left,
  isActive,
  keepParentScrollPosition,
}) => {
  const location = useLocation()
  const history = useHistory()
  const match = useRouteMatch()

  const handleClick = useCallback(
    event => {
      event.stopPropagation()
      if (isBackAction) {
        history.goBack()
      }
    },
    [history, isBackAction]
  )

  const canGoBack = location?.state?.canGoBack || true
  if (isBackAction && !canGoBack) {
    return null
  }

  const urlQuery = location.search

  let to = null

  if (!isBackAction) {
    to = {
      routeKey: 'PROTOTYPE',
      routeParams: {
        shareID: match.params.shareID,
        permanentArtboardShortId: destinationArtboardPermShortId,
      },
      state: {
        fromOverview: location?.state?.fromOverview || false,
        transitionType: animationTypeToTransitionType[animationType],
        fromArtboardId: match.params.permanentArtboardShortId,
        toArtboardId: destinationArtboardPermShortId,
        keepParentScrollPosition,
      },
      search: urlQuery,
    }
  }

  // Stop propagation `onMouseDown` and `onTouchStart` so that FlowView will not flash
  // Hotzones when an actual Hotzone is clicked.
  const hitAreaProps = {
    onMouseDown: stopPropagation,
    onTouchStart: stopPropagation,
    onClick: handleClick,
    to,
    width: px(Math.floor(width * scale)),
    height: px(Math.floor(height * scale)),
    top: px(Math.floor(top * scale)),
    left: px(Math.floor(left * scale)),
    isActive,
  }

  return isBackAction ? (
    <HitAreaBox {...hitAreaProps} />
  ) : (
    <VersionLinkHitAreaBox {...hitAreaProps} />
  )
}
Hotzone.propTypes = {
  isBackAction: PropTypes.bool,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }),
  animationType: PropTypes.oneOf([
    'fromBottom',
    'fromLeft',
    'fromRight',
    'fromTop',
    'none',
  ]),
  destinationArtboardPermShortId: PropTypes.string,
  match: PropTypes.shape({
    params: PropTypes.shape({
      shareID: PropTypes.string.isRequired,
      permanentArtboardShortId: PropTypes.string.isRequired,
    }).isRequired,
  }),
  location: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  scale: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isActive: PropTypes.bool,
  keepParentScrollPosition: PropTypes.bool,
}

export default Hotzone
